import { parseNames } from "./nameParser";

const normalize = (text) => String(text || "")
  .normalize("NFKC")
  .toLowerCase()
  .replace(/no\.?\s*(\d+)/gi, (_, n) => `no.${n} no ${n} ${n}`)
  .replace(/เบอร์\s*(\d+)/g, (_, n) => `เบอร์ ${n} ${n}`)
  .replace(/#\s*(\d+)/g, (_, n) => `#${n} ${n}`);

const normalizePhrase = (text) => normalize(text).trim().replace(/\s+/g, " ");

// Rank exact primary names, exact aliases, prefixes, then contained phrases.
// Existing token scores and input order (popularity/current floor) break ties.
export function searchDestinations(destinations, query) {
  const phrase = normalizePhrase(query);
  const tokens = phrase.split(/\s+/).filter(Boolean);
  if (!tokens.length) return destinations;
  return destinations.map((destination) => {
    const nameVariants = [destination.name, ...parseNames(destination.name).all].map(normalizePhrase);
    const primaryVariants = parseNames(String(destination.name || "").split(/[,;|/]/)[0]).all.map(normalizePhrase);
    const phraseRank = primaryVariants.includes(phrase) ? 4
      : nameVariants.includes(phrase) ? 3
      : nameVariants.some((name) => name.startsWith(phrase)) ? 2
      : nameVariants.some((name) => name.includes(phrase)) ? 1 : 0;
    const names = nameVariants.join(" ");
    const metadata = normalize([
      destination.description, destination.category,
      destination.floorName, destination.buildingName,
    ].join(" "));
    const nameMatches = tokens.filter((token) => names.includes(token)).length;
    const metadataMatches = tokens.filter((token) => metadata.includes(token)).length;
    return { destination, phraseRank, score: nameMatches * (tokens.length + 1) + metadataMatches };
  })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.phraseRank - a.phraseRank || b.score - a.score)
    .map(({ destination }) => destination);
}
